import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.activeClasses = (this.element.dataset.dropdownActiveClass || "")
      .split(" ")
      .filter(Boolean);
    // read transition classes
    this.enterFrom = (
      this.menuTarget.dataset.transitionEnterFrom || "opacity-0 scale-95"
    ).split(" ");
    this.enterTo = (
      this.menuTarget.dataset.transitionEnterTo || "opacity-100 scale-100"
    ).split(" ");
    this.leaveFrom = (
      this.menuTarget.dataset.transitionLeaveFrom || "opacity-100 scale-100"
    ).split(" ");
    this.leaveTo = (
      this.menuTarget.dataset.transitionLeaveTo || "opacity-0 scale-95"
    ).split(" ");
  }

  toggle(e) {
    if (this.menuTarget.classList.contains("hidden")) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.menuTarget.classList.remove("hidden");
    this.menuTarget.classList.remove(...this.leaveTo);
    this.menuTarget.classList.add(...this.enterFrom);

    // Trigger reflow
    void this.menuTarget.offsetWidth;

    this.menuTarget.classList.remove(...this.enterFrom);
    this.menuTarget.classList.add(...this.enterTo);

    if (this.activeClasses.length > 0) {
      const button = this.element.querySelector("button");
      if (button) button.classList.add(...this.activeClasses);
    }
  }

  hide(e) {
    if (e && e.type === "click") {
      const button = this.element.querySelector("button");
      if (button && button.contains(e.target)) {
        return; // Let toggle() handle it
      }
    }

    this.menuTarget.classList.remove(...this.enterTo);
    this.menuTarget.classList.add(...this.leaveTo);

    // Usually wait for transition end, or just a small timeout
    setTimeout(() => {
      // Only hide if we actually meant to hide and didn't trigger show again
      if (this.menuTarget.classList.contains(...this.leaveTo)) {
        this.menuTarget.classList.add("hidden");
      }
    }, 150);

    if (this.activeClasses.length > 0) {
      const button = this.element.querySelector("button");
      if (button) button.classList.remove(...this.activeClasses);
    }
  }
}
